import { GET_COMMENTS, CREATE_COMMENT, UPDATE_COMMENT, DELETE_COMMENT, GET_UNRESOLVED_COUNTS } from './comment.types';

export const commentActions = {
  getComments: (taskId) => ({ type: GET_COMMENTS, payload: taskId }),
  createComment: (data) => ({ type: CREATE_COMMENT, payload: data }),
  updateComment: (id, data) => ({ type: UPDATE_COMMENT, payload: { id, data } }),
  deleteComment: (id) => ({ type: DELETE_COMMENT, payload: id }),
  getUnresolvedCounts: (taskIds) => ({ type: GET_UNRESOLVED_COUNTS, payload: taskIds }),
};
